"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = void 0;
exports.store = {
    androidPackageName: "app.rsonav",
    iosBundleId: "app.rsonav",
    iosAppStoreId: "1489322630",
};
//# sourceMappingURL=store.js.map